import { USER_LIST, UPDATE_USER, DELETE_USER } from "../../admin-constants";


const initialState = {
  userListData: [],
  userUpdateData: [],
  deleteUserData: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case USER_LIST: {
      return {
        ...state,
        userListData: payload,
      };
    }
        case UPDATE_USER: {
      return {
        ...state,
          userUpdateData: payload,
      };
    }

    case DELETE_USER: {
      const updatedUserList = state.userListData.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      return {
        ...state,
        userListData: updatedUserList,
      };
    }

    default:
      return state;
  }
};

export default reducer;